import { Fancybox } from "@fancyapps/ui"

const fancyboxOptions = {
	infinite: false,
	dragToClose: false,
	autoFocus: false,
	template: {
		closeButton: `<div class="modal__close"><span></span></div>`
	},
	showClass: "fancybox-is-open",
	hideClass: "fancybox-is-closing",
	animated: false
}

Fancybox.bind(".js-modal", fancyboxOptions)

export default fancyboxOptions
